/* Get header and footer heights */
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.section-header');
  var footer = document.querySelector('.section-footer');

  var headerHeight = header.offsetHeight;
  var footerHeight = footer.offsetHeight;

  document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  document.documentElement.style.setProperty('--footer-height', footerHeight + 'px');
});

/* Size Guide */
// Get the elements
const sizeGuideModal = document.getElementById("size-guide");
const sizeGuideBtn = document.getElementById("size-guide-btn");
const closeBtn = document.getElementById("close-btn");

// Function to open the modal
function openModal() {
  sizeGuideModal.classList.add("show");
  setTimeout(() => {
    sizeGuideModal.querySelector('.size-guide-content').classList.add("show");
  }, 10); // Delay to allow initial fade-in effect
}

// Function to close the modal
function closeModal() {
  sizeGuideModal.querySelector('.size-guide-content').classList.remove("show");
  setTimeout(() => {
    sizeGuideModal.classList.remove("show");
  }, 100); // Match the fade-out duration
}

// Event listener to open the modal when the button is clicked
sizeGuideBtn.addEventListener("click", openModal);

// Event listener to close the modal when the close button is clicked
closeBtn.addEventListener("click", closeModal);

// Event listener to close the modal if the user clicks outside the modal content
sizeGuideModal.addEventListener("click", function (event) {
  if (event.target === sizeGuideModal) {
    closeModal();
  }
});


/* Format titles */
const headings = document.querySelectorAll('.card__heading, .product__title h1, .featured-product .product__title, .cart-item__name, .page-title, .related-products .card__heading.h5, .card__heading.h5');

headings.forEach(heading => {
  heading.innerHTML = heading.innerHTML.replace(/\|/g, '<br><small />');
});